import React from "react";
import { useIntl } from "react-intl";

import { TextInputCard } from "@deliverr/ui-facility/lib-facility/flow/cards";
import { useReopenPalletScanPallet } from "./useReopenPalletScanPallet";
import { WarehouseMessages } from "@deliverr/ui-facility/lib-facility/utils";

export interface ReopenPalletScanPalletCardProps {
  disabled?: boolean;
  newest?: boolean;
}

export const ReopenPalletScanPalletCard: React.FC<ReopenPalletScanPalletCardProps> = ({ disabled, newest }) => {
  const { palletLabelId, onPalletLabelIdChange, submitPalletLabelId } = useReopenPalletScanPallet();
  const { formatMessage } = useIntl();
  const onSubmit = async () => {
    await submitPalletLabelId(palletLabelId);
  };

  return (
    <TextInputCard
      onSubmit={onSubmit}
      newest={newest}
      icon="scan"
      accentColor="BLUE"
      title="Scan the pallet to re-open"
      value={palletLabelId}
      onChange={onPalletLabelIdChange}
      disabled={disabled}
      placeholder={formatMessage(WarehouseMessages.palletIdentifierPlaceholder)}
    />
  );
};
